import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';

import { SurveySendIcon } from '../../../../../assets/svg/survey/SurveySendIcon';
import InputText from '../../../../../react-components/InputText';
import { Text } from '../../../../../react-components/Text';

type RouteSurveyCommentsProps = {
  isUpdating: boolean;
  onComment: (comments: string) => void;
};

export const RouteSurveyComments = ({ isUpdating, onComment }: RouteSurveyCommentsProps) => {
  const [endSurvey, setEndSurvey] = useState<boolean>(false);
  const [surveyDataComments, setSurveyDataComments] = useState<string | undefined>();

  return (
    <Grid key="step-1" className="animate__animated animate__fadeIn">
      <Text
        variant="body-large"
        intlId="route_survey.step-2.title.v2"
        style={{ color: RoutalPalette.secondary00, textAlign: `center` }}
      />
      <VSpacer small />
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        flexWrap={`nowrap`}
        position={`relative`}
      >
        <InputText
          placeholderIntlId="route_survey.comments_ph"
          multiline
          rowsMin={4}
          disabled={isUpdating || endSurvey}
          fieldValue={surveyDataComments || ``}
          onChange={(value: string) => setSurveyDataComments(value)}
          bGColor={RoutalPalette.neutral02}
          hoverBGColor="transparent"
          inputContainerStyles={{
            width: `100%`,
            borderColor: RoutalPalette.neutral02,
          }}
          inputStyles={{
            width: `100%`,
            color: RoutalPalette.primary80,
            borderColor: RoutalPalette.neutral02,
          }}
        />
        <Grid
          style={{
            position: `absolute`,
            height: `30px`,
            width: `30px`,
            borderRadius: `10px`,
            right: 6,
            bottom: 6,
            backgroundColor: RoutalPalette.secondary40,
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`,
            visibility: surveyDataComments ? `visible` : `hidden`,
          }}
          className="animate__animated animate__fadeIn"
          onClick={() => {
            if (!isUpdating) {
              onComment(surveyDataComments || ``);
              setEndSurvey(true);
            }
          }}
        >
          <SurveySendIcon />
        </Grid>
      </Grid>
    </Grid>
  );
};
